"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = OpenMap;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function OpenMap(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "open-map"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54.4,35.835A4.664,4.664,0,1,0,49.739,40.5,4.664,4.664,0,0,0,54.4,35.835Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M90,7.5H10A2.5,2.5,0,0,0,7.5,10V90A2.5,2.5,0,0,0,10,92.5H90A2.5,2.5,0,0,0,92.5,90V10A2.5,2.5,0,0,0,90,7.5ZM45.54,51.363v0L39.918,41.109c-.068-.122-.139-.248-.216-.4l-.016-.03-.041-.075q-.027-.07-.06-.138a11.193,11.193,0,0,1-1.16-4.964,11.314,11.314,0,1,1,22.628,0,11.207,11.207,0,0,1-1.16,4.964,1.4,1.4,0,0,0-.06.138l-.023.042-.035.063c-.068.132-.139.261-.227.414l-5.61,10.234h0l-4.2,7.66ZM62.165,42.6c.094-.165.185-.33.256-.467l.133-.241a1.49,1.49,0,0,0,.1-.245,14.179,14.179,0,0,0,1.307-4.552,14.314,14.314,0,1,0-28.54-1.584,14.158,14.158,0,0,0,1.385,6.115,1.508,1.508,0,0,0,.112.262l.117.213c.087.167.177.33.259.474l4.392,8.012H12.5V12.5h75V50.582H57.786ZM12.5,87.5V68.966H60.107V87.5ZM63.107,67.467a1.5,1.5,0,0,0-1.5-1.5H12.5V53.582H43.335l4.389,8a1.483,1.483,0,0,0,.255.34,2.49,2.49,0,0,0,3.519,0,1.483,1.483,0,0,0,.255-.34l4.388-8H87.5V65.967H76.992a1.5,1.5,0,0,0-1.5,1.5V87.5H63.108Zm15.385,1.5H87.5V87.5H78.492Z"
  })))));
}